/**
 * Filters toggle functionality for resources pages
 */

const FILTERS_SHELL_SELECTOR = '[data-resources-filters-shell]';
const FILTERS_TOGGLE_SELECTOR = '[data-resources-filters-toggle]';
const FILTERS_PANEL_SELECTOR = '[data-resources-filters-panel]';

export const initFiltersToggle = (): void => {
  const shell = document.querySelector<HTMLElement>(FILTERS_SHELL_SELECTOR);
  const layout = document.querySelector<HTMLElement>('.resources-layout');

  if (!shell || !layout) {
    return;
  }

  const toggle = shell.querySelector<HTMLButtonElement>(FILTERS_TOGGLE_SELECTOR);
  const panel = shell.querySelector<HTMLElement>(FILTERS_PANEL_SELECTOR);

  if (!toggle || !panel) {
    return;
  }

  const applyState = (isOpen: boolean): void => {
    toggle.setAttribute('aria-expanded', String(isOpen));
    panel.setAttribute('aria-hidden', String(!isOpen));
    layout.classList.toggle('resources-layout--filters-collapsed', !isOpen);
    shell.dataset.state = isOpen ? 'expanded' : 'collapsed';
  };

  applyState(false);

  toggle.addEventListener('click', () => {
    const isOpen = toggle.getAttribute('aria-expanded') === 'true';
    applyState(!isOpen);
  });
};
